export const ON_AVATAR_UPLOAD = '@ARI/Questionnaire/AvatatUpload/ON_AVATAR_UPLOAD';
export const SET_AVATAR = '@ARI/Questionnaire/AvatatUpload/SET_AVATAR';
export const ON_AVATAR_DELETE = '@ARI/Questionnaire/AvatatUpload/ON_AVATAR_DELETE';